import { Route, Routes } from 'react-router-dom'
import { Starter } from '../Starter/Starter'
import Tetris from '../../game/Tetris/Tetris'
import { TicTacToe } from '../../game/TicTacToe/TicTacToe'
import { TicTacToeOnline } from '../../game/TicTacToe/TicTacToeOnline'
import { GamePage } from '../../game/GamePage/GamePage'
import { DoodleJump } from '../../game/DoodleJump/DoodleJump'
import { useEffect } from 'react'


export const GameRouter = () => {

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to the top of the new page
    }, []);

    return (
        <Routes>
            <Route path='/' element={<GamePage />}></Route>
            <Route path='/TicTacToe' element={<TicTacToe />}></Route>
            <Route path='/Doodle-Jump' element={<DoodleJump />}></Route>
            {/* <Route  path='/OnlineTicTacToe' element={<TicTacToeOnline />}></Route> */}
            {/* <Route  path='/Tetris' element={<Tetris />}></Route> */}
        </Routes>
    )
}